import * as go from "gojs";
import { useEffect, useRef, useState } from "react";
import {
  ExecuteLayoutEventMethods,
  ChangePageDataSetState,
} from "../../../General/commonFunctions";

export default function FactsOrgChart({ props }) {
  const getCurrentDataSet = () => {
    let listds = ChangePageDataSetState(props.source);
    if (!listds) return null;
    return listds[props.datasets[0]];
  };

  const diagramRef = useRef();

  const [chartsource, setData] = useState(getCurrentDataSet());

  useEffect(() => {
    const $ = go.GraphObject.make;

    const diagram = $(go.Diagram, diagramRef.current, {
      initialAutoScale: go.Diagram.UniformToFill,
      layout: $(go.TreeLayout, {
        angle: 90,
        layerSpacing: 30,
      }),
      "animationManager.isEnabled": true,
      "animationManager.duration": 300,
      "undoManager.isEnabled": true,
    });

    // Node Template
    diagram.nodeTemplate = $(
      go.Node,
      "Vertical", // Changed from "Horizontal" to "Vertical"
      { selectionAdorned: false },
      {
        doubleClick: function (e, node) {
          if (props?.nodedoubleclick) {
            (async () => {
              await ExecuteLayoutEventMethods(props.nodedoubleclick, node.data);
            })();
          }
        },
      },
      $(
        go.Panel,
        "Table",
        { minSize: new go.Size(150, 50) },
        new go.Binding(
          "minSize",
          "Size",
          (s) => new go.Size(s.width, s.height)
        ),
        new go.Binding("background", "backgroundColor"),
        new go.Binding("itemArray", "keyvalues"),
        {
          itemTemplate: $(
            go.Panel,
            "TableRow",
            $(
              go.TextBlock,
              {
                font: "12px sans-serif",
                margin: new go.Margin(2, 0, 0, 0),
              },
              new go.Binding(
                "font",
                "",
                (data, obj) => data.font ?? obj.part.data.font
              ),
              new go.Binding("text", "value"),
              new go.Binding(
                "stroke",
                "",
                (data, obj) => data.color ?? obj.part.data.color
              )
            )
          ),
        }
      ),
      $("TreeExpanderButton", {
        alignment: go.Spot.Center,
        alignmentFocus: go.Spot.Top,
        margin: new go.Margin(4, 0, 0, 0),
        "ButtonBorder.fill": "#E0E0E0",
      })
    );
    diagram.linkTemplate = $(
      go.Link,
      { routing: go.Link.Orthogonal, corner: 5 },
      $(go.Shape),
      $(go.Shape, { toArrow: "Standard" })
    );

    diagram.nodeTemplate.contextMenu = $(
      "ContextMenu",
      $("ContextMenuButton", $(go.TextBlock, "Expand"), {
        click: (e, obj) => {
          const node = obj.part.adornedPart;
          if (node !== null) node.expandTree();
        },
      }),
      $("ContextMenuButton", $(go.TextBlock, "Collapse"), {
        click: (e, obj) => {
          const node = obj.part.adornedPart;
          if (node !== null) node.collapseTree();
        },
      })
    );

    diagram.model = new go.TreeModel(chartsource);

    return () => (diagram.div = null);
  }, [chartsource]);

  const exportImage = () => {
    if (!diagramRef.current) return;
    const diagram = go.Diagram.fromDiv(diagramRef.current);
    const imgData = diagram.makeImageData({ scale: 1, background: "white" });

    const link = document.createElement("a");
    link.download = "orgchart.png";
    link.href = imgData;
    link.click();
  };

  return (
    <div ref={diagramRef} {...props} />
    // <div>
    /* <button
        className="bg-blue-500 text-white px-4 py-2 rounded my-2"
        onClick={exportImage}
      >
        Export as Image
    //   </button> */
    //   <div
    //     ref={diagramRef}
    //     style={{ width: "100%", height: "600px", border: "1px solid #ccc" }}
    //   />
    // </div>
  );
}
